import classNames from 'classnames';
import { useIsGlobetrotter } from '@bwoty-web/ui-kit/hooks';

import './tdmSearch.scss';

const TdmSearchPlaceholder = () => {
  const classes = classNames('tdm-search-placeholder', {
    'tdm-search-placeholder--globetrotter': useIsGlobetrotter(),
  });

  return <div className={classes} />;
};

export default TdmSearchPlaceholder;
